export const DEBOUNCE_500 = 500;
export const DEBOUNCE_100 = 100;
